/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { ColDef } from 'ag-grid-community';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { CheckInfoType } from 'adapters/types';
import { RIGHT_ALIGNED } from 'common/constants';
import { gridHeaders } from './messages';
import { PrintedOKCheckbox } from './PrintedOKCheckbox';

export const usePrintSuccessDialogColumns = (): ColDef[] => {
  const intl = useIntl();
  return useMemo(
    () => [
      {
        field: 'printedOK',
        headerName: intl.formatMessage(gridHeaders.printedOK),
        cellRenderer: PrintedOKCheckbox,
        cellRendererParams: ({ data }: { data: CheckInfoType }) => data,
        maxWidth: 120
      },
      {
        field: 'vendorNo',
        headerName: intl.formatMessage(gridHeaders.vendorNo),
        sortable: true,
        maxWidth: 115
      },
      {
        field: 'vendorName',
        headerName: intl.formatMessage(gridHeaders.vendorName),
        sortable: true,
        maxWidth: 130
      },
      {
        field: 'checkNumber',
        headerName: intl.formatMessage(gridHeaders.checkNo),
        sortable: true,
        maxWidth: 106
      },
      {
        field: 'checkAmount',
        headerName: intl.formatMessage(gridHeaders.amount),
        sortable: true,
        maxWidth: 110,
        type: RIGHT_ALIGNED
      }
    ],
    // REASON FOR DISABLING: We do not want cell renderers to re-render when column defs are updated.
    // To ensure they don't change, we need to wrap them in useMemo() and pass an empty dependency array.
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
    []
  );
};
